// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout_wrapper__iFXSB","section":"Layout_section__vEyGz"};